<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <table class="setting-table">
        <tr>
          <td>
            <!-- <input
              type="checkbox"
              id="switchNotification"
              @change="chenge"
            /><label for="switchNotification"></label> -->
          </td>
          <td>قوانین</td>
          <td>
            <img src="@/assets/icons/rules.svg" />
          </td>
        </tr>
        <tr>
          <td>
            <!-- <input
              type="checkbox"
              id="switchNotification"
              @change="chenge"
            /><label for="switchNotification"></label> -->
          </td>
          <td>راهنما</td>
          <td>
            <img src="@/assets/icons/guide.svg" />
          </td>
        </tr>
      </table>
      <div class="sectionsperator"></div>
      <table class="setting-table end-page">
        <tr>
          <td>
            <!-- <input
              type="checkbox"
              id="switchNotification"
              @change="chenge"
            /><label for="switchNotification"></label> -->
          </td>
          <td>پشتیبانی</td>
          <td>
            <img src="@/assets/icons/menu_support.svg" />
          </td>
        </tr>
        <tr @click="ticketRouteHandler">
          <td>
            <!-- <input
              type="checkbox"
              id="switchNotification"
              @change="chenge"
            /><label for="switchNotification"></label> -->
          </td>
          <td>ارسال تیکت</td>
          <td>
            <!-- <img src="@/assets/icons/menu_support.svg" /> -->
          </td>
        </tr>
        <tr @click="phoneCallHandler">
          <td>
            <!-- <input
              type="checkbox"
              id="switchNotification"
              @change="chenge"
            /><label for="switchNotification"></label> -->
          </td>
          <td>تماس مستقیم با اپراتور</td>
          <td>
            <!-- <img src="@/assets/icons/menu_support.svg" /> -->
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    phoneCallHandler() {
      window.open("tel:900300400");
    },
    closeModal() {
      this.isShow = false;
    },
    goBack() {
      this.$router.back();
    },
    ticketRouteHandler() {
      this.$router.push({ name: "Ticket" });
    },
  },
};
</script>

<style scoped>
table.setting-table {
  width: 100%;
  height: 12% !important;
}
table.setting-table.end-page {
  position: absolute;
  bottom: 0;
  right: 24px;

  width: 75%;
  height: 22% !important;
}
.sectionsperator {
  border-top: 1px solid #ddd;
  position: fixed;
  bottom: 23%;
  width: 75%;
  margin: auto;
  left: 15%;
}
</style>
